import { render, staticRenderFns } from "./startCatTesting.vue?vue&type=template&id=38a56900&scoped=true&"
import script from "./startCatTesting.vue?vue&type=script&lang=js&"
export * from "./startCatTesting.vue?vue&type=script&lang=js&"
import style0 from "./startCatTesting.vue?vue&type=style&index=0&id=38a56900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a56900",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
